/**
 * Horizontal bars with the value written on every row.
 *
 * Used for the pipeline funnel and the breakdowns, where the category label is
 * a word (not a date) and reads far better beside the bar than under it.
 * Values are always printed: that is the "relief" that keeps the lighter
 * palette slots readable regardless of contrast.
 */
const HBarChart = ({ rows = [], formatValue = (v) => v, emptyLabel = 'No data' }) => {
  if (!rows.length) return <p className="chart-empty">{emptyLabel}</p>;

  const max = Math.max(1, ...rows.map((row) => Number(row.value) || 0));

  return (
    <ul className="hbar">
      {rows.map((row) => (
        <li key={row.key ?? row.label} className="hbar__row">
          <span className="hbar__label" title={row.label}>
            {row.label}
          </span>
          <span className="hbar__track">
            <span
              className="hbar__fill"
              style={{ width: `${((Number(row.value) || 0) / max) * 100}%`, background: row.color }}
            />
          </span>
          <span className="hbar__value">{formatValue(row.value)}</span>
          {row.note !== undefined ? <span className="hbar__note">{row.note}</span> : null}
        </li>
      ))}
    </ul>
  );
};

export default HBarChart;
